import { Buffergs925ekssbch as Buffer } from './Buffer.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealSourceClass;
function RealSource() {
  if (RealSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.k4g_1 = source;
        this.l4g_1 = false;
        this.m4g_1 = new (Buffer())();
      }
      n3x() {
        return this.m4g_1;
      }
      h4f(sink, byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.l4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message_0));
        }
        if (this.m4g_1.v2() === 0n) {
          var read = this.k4g_1.h4f(this.m4g_1, 8192n);
          if (read === -1n)
            return -1n;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = this.m4g_1.v2();
        var toRead = byteCount <= b ? byteCount : b;
        return this.m4g_1.h4f(sink, toRead);
      }
      o3x() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.l4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return this.m4g_1.o3x() && this.k4g_1.h4f(this.m4g_1, 8192n) === -1n;
      }
      p3x(byteCount) {
        if (!this.u3x(byteCount))
          throw EOFException().m4e("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
      }
      u3x(byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.l4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message_0));
        }
        while (this.m4g_1.v2() < byteCount) {
          if (this.k4g_1.h4f(this.m4g_1, 8192n) === -1n)
            return false;
        }
        return true;
      }
      x3x() {
        this.p3x(1n);
        return this.m4g_1.x3x();
      }
      f4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        if (this.m4g_1.v2() === 0n) {
          var read = this.k4g_1.h4f(this.m4g_1, 8192n);
          if (read === -1n)
            return -1;
        }
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.m4g_1.v2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0);
        var tmp$ret$2 = a <= b ? a : b;
        var toRead = convertToInt(tmp$ret$2);
        return this.m4g_1.f4f(sink, startIndex, startIndex + toRead | 0);
      }
      j4f(sink, byteCount) {
        try {
          this.p3x(byteCount);
        } catch ($p) {
          if ($p instanceof EOFException()) {
            var e = $p;
            sink.i4f(this.m4g_1, this.m4g_1.v2());
            throw e;
          } else {
            throw $p;
          }
        }
        this.m4g_1.j4f(sink, byteCount);
      }
      k4f(sink) {
        var totalBytesWritten = 0n;
        while (!(this.k4g_1.h4f(this.m4g_1, 8192n) === -1n)) {
          var emitByteCount = this.m4g_1.d4f();
          if (emitByteCount > 0n) {
            totalBytesWritten = add(totalBytesWritten, emitByteCount);
            sink.i4f(this.m4g_1, emitByteCount);
          }
        }
        if (this.m4g_1.v2() > 0n) {
          totalBytesWritten = add(totalBytesWritten, this.m4g_1.v2());
          sink.i4f(this.m4g_1, this.m4g_1.v2());
        }
        return totalBytesWritten;
      }
      w4e() {
        this.p3x(2n);
        return this.m4g_1.w4e();
      }
      s3z() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.l4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return buffered(new (PeekSource())(this));
      }
      q6() {
        if (this.l4g_1)
          return Unit_instance;
        this.l4g_1 = true;
        this.k4g_1.q6();
        this.m4g_1.f5();
      }
      toString() {
        return 'buffered(' + toString(this.k4g_1) + ')';
      }
    }
    initMetadataForClass($, 'RealSource', VOID, VOID, [Source()]);
    RealSourceClass = $;
  }
  return RealSourceClass;
}
//region block: exports
export {
  RealSource as RealSource1sojixeyllf40,
};
//endregion

//# sourceMappingURL=RealSource.mjs.map
